import * as yup from "yup";

export const userInviteSchema = yup.object().shape({
    email: yup.string().email("Please enter a valid Email address").required("Field is required"),
    isClientAdmin: yup.bool(),
});
